var _defs, _path, _path2, _circle, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _path7, _path8, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElement3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110.48 104.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#220959;stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill:#220959;}.cls-3{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.7,99A26.5,26.5,0,1,1,79.38,47.57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.37,103.11A26.52,26.52,0,0,1,41.44,73.45"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 74.2,
    cy: 73.88,
    r: 22.93
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.49,59.27c7.24-8.64,20.5-9.45,29.63-1.81S98.77,78.3,91.53,87"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.11,38.57A33,33,0,0,1,17.44,85"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.05,54.37A33,33,0,1,1,96.46,25.51"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.31,55.38A33,33,0,0,1,41.44,9.79"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 29.55,
    y: 57.1,
    width: 10.09,
    height: 10.09,
    rx: 2.94
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 57.13,
    y: 0.86,
    width: 10.09,
    height: 10.09,
    rx: 2.94,
    transform: "translate(19.99 -40.14) rotate(42.08)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.86,
    y: 28.36,
    width: 10.09,
    height: 10.09,
    rx: 2.94,
    transform: "translate(23.91 4.65) rotate(42.08)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103,82.13A33,33,0,1,0,43.56,53.27"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.2,19.45a33,33,0,0,0-36,29.71"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 100.4,
    y: 84.87,
    width: 10.09,
    height: 10.09,
    rx: 2.94,
    transform: "translate(210.88 179.82) rotate(-180)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 72.81,
    y: 28.63,
    width: 10.09,
    height: 10.09,
    rx: 2.94,
    transform: "translate(158.21 6.48) rotate(137.92)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElement3);
export default __webpack_public_path__ + "static/media/Element3.cefdc3192b2f4dd28951b2a366b612ea.svg";
export { ForwardRef as ReactComponent };